import {
  DTOCreateForgeArtifact,
  DTOCreateForgeArtifactResponse,
  DTODeleteForgeArtifactResponse,
  DTOUpdateForgeArtifact,
  DTOUpdateForgeArtifactResponse,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeArtifactsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(workspaceId: string, projectId: string, iterationId: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/artifacts`,
      DTOUpdateForgeArtifactResponse,
      {
        method: "GET",
      }
    );
  }

  create(workspaceId: string, projectId: string, iterationId: string, body: DTOCreateForgeArtifact) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/artifacts`,
      DTOCreateForgeArtifactResponse,
      {
        method: "POST",
        body,
      }
    );
  }

  update(workspaceId: string, projectId: string, iterationId: string, id: string, body: DTOUpdateForgeArtifact) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/artifacts/${id}`,
      DTOCreateForgeArtifactResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(workspaceId: string, projectId: string, iterationId: string, id: string) {
    return this.requestExecutor.json(
      `/workspaces/${workspaceId}/forge/projects/${projectId}/iterations/${iterationId}/artifacts/${id}`,
      DTODeleteForgeArtifactResponse,
      {
        method: "DELETE",
      }
    );
  }
}
